import { notification } from "antd";
import AccessControl from "components/common/AccessControl/accessControl";
import { Form, Formik } from "formik";
import { get } from "lodash";
import React from "react";
import Dropzone from "react-dropzone";

import { UploadDropzone } from "../../../components/icons";
import { downloadTemplates } from "../../../config/index";

const ExportStreamIdCsv = ({ ...props }) => {
  const { importS3GlacierStreams } = props;
  const onFileDrop = async (files) => {
    let data = new FormData();
    data.append("file", files[0]);
    data.append("filename", files[0].name);
    data.append("userId", localStorage.getItem("__uid"));
    const { value } = await importS3GlacierStreams(data);
    value.status
      ? notification["success"]({ message: "S3 glacier stream restoring process running background!" })
      : notification["error"]({ message: value.message });
  };
  return (
    <div className="col-md-12">
      {" "}
      <Formik enableReinitialize>
        {({ errors, touched, setFieldValue, values }) => (
          <div className="modal-content">
            <Form>
              <div className="react-modal-header">
                <h5 className="react-modal-title">Upload CSV</h5>
                {/* <CloseModal /> */}
              </div>
              <div className="react-modal-body">
                <div className="form-container">
                  <AccessControl code="upload_stream_csv" page="organization-profile">
                    <Dropzone
                      accept="text/*"
                      onDrop={(acceptedFiles) => {
                        onFileDrop(acceptedFiles);
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div className="dropzone-inner" {...getRootProps()}>
                            <input {...getInputProps()} type="file" accept=".csv" />
                            <div className="dropzone-icon">
                              <UploadDropzone />
                            </div>
                            <div className="dropzone-title">Upload a File</div>
                            <div className="dropzone-subtitle">Upload a CSV File</div>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                  </AccessControl>
                </div>
                <div className="react-modal-footer justify-content-center">
                  <div className="react-foo-container">
                    <div className="right-btn-block">
                      <AccessControl code="download_stream_csv" page="organization-profile">
                        <a
                          href={get(
                            downloadTemplates,
                            "s3Glacier",
                            "https://d7xz21f54epr.cloudfront.net/3tBwdNb9s/csv/export_csv_streamId.csv",
                          )}
                          className="btn-text"
                        >
                          Download Sample
                        </a>
                      </AccessControl>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default ExportStreamIdCsv;
